<template>
	<div>
		<selectList
			v-model="itemSelected"
			:accessConfirm="$access.jobStage.edit"
			:accessDelete="$access.jobStage.delete"
			:selectLabel="$t('entities.jobStage.props.description')"
			:items="value"
			:index="indexSelected"
			@newItem="edit(getModelDefault(), null, true)"
			@duplicateItem="edit(getModelDefault(), null, true, true)"
			@input="edit($event, value.indexOf($event), true)"
			@delete="remove(indexSelected)"
			@confirm="confirm(true, $refs.form.isValid())"
			:loading="loading"
			:confirmButton="itemSelected != null"
			@cancel="itemSelected = null"
			itemText="description"
			@saveChanges="saveChanges"
			:sort="
				(a, b) => {
					return a.seq > b.seq ? 1 : a.seq < b.seq ? -1 : 0;
				}
			"
		>
			<jobStageForm
				ref="form"
				v-if="itemSelected"
				v-model="itemSelected"
				:environmentId="environmentId"
			/>
		</selectList>
	</div>
</template>

<script>
	import jobStageForm from "@/components/forms/jobStages/jobStageForm";
	import objectValueListMixing from "@/mixins/objectPageLists/objectValueListMixing.js";
	import selectList from "@/components/selectLists/selectList";
	export default {
		props: ["value", "environmentId"],
		components: {
			jobStageForm,
			selectList,
		},
		mixins: [objectValueListMixing],
		data() {
			return {
				loading: false,
			};
		},
		watch: {
			value() {
				this.itemSelected = null;
			},
		},
		computed: {},
		methods: {
			saveChanges() {
				if (!this.itemSelected) return true;

				let isValid = this.$refs.form.isValid();
				if (isValid) {
					this.confirm(true, this.$refs.form.isValid());
					this.itemSelected = null;
					return true;
				}
				return false;
			},
			validate() {
				// let isValid = itemSelected == null || this.$refs.form.isValid();
			},
			getModelDefault() {
				return {
					description: "",
					stages: [],
					jobStageItemProds: [],
					jobStageItemConss: [],
					jobId: null,
				};
			},
		},
	};
</script>
